const sumSidebar=[                     //侧边导航栏  //rank： 1总负责人，2部门负责人，3组员
    {name:'互评分数填写',index:'/mutualEvaluation',rank:3},
    {name:'考核评分表填写',index:'/AssessFormPage',rank:3},
    {name:'基础人员信息配置',index:'/deInforSettBase',rank:2},
    {name:'每期人员信息维护',index:'/deInforSett',rank:2},
    {name:'互评名单设置',index:'/demUtualEvaluaSett',rank:2},
    {name:'基础数据导入',index:'/deDataImpor',rank:2},
    {name:'考核评分表设置',index:'/assessFormSetting',rank:1},
    {name:'设置',index:'/setting',rank:1,childs:[
        {name:'角色权限设置',index:'/roleSetting'},
    ]},
    {name:'报表',index:'/report',rank:1,childs:[
        {name:'公司报表',index:'/reportForms'},
        {name:'部门报表',index:'/departmentReportForms'},
        {name:'低分报表',index:'/lowGradeReportForms'},
    ]}
]

const tableSeleType=[
    {label:'自评',value:1},
    {label:'同事评分',value:2},
    {label:'考评人评',value:3},
    {label:'组员评组长',value:4},
    {label:'组员评专员',value:5},
    {label:'不计算类型',value:6},
]

const designFormulas=[
    {label:'不计分,仅作参考',value:0},
    {label:'完成率≥95%,可得30分;95%>完成率≥85%,可得25分;85%>完成率≥75%,可得20分;75%>完成率≥65%,可得15分;完成率65%以下,可得0分',value:1},
    {label:'达成比率≥95%,可得10分;95%>达成比率≥90%,可得8分;90%>达成比率≥85%,可得5分;85%>达成比率≥80%,可得2分;80%>达成比率,可得0分;',value:2},
    {label:'0-3次得10分,4-5次得8分,超过5次后每次少一分',value:3},
    {label:'0次得10分,1-2次得5分,3次及以上得0分',value:4},
    {label:'0-5次得5分,超过5次后每次少1分',value:5},
    {label:'0-1次得1分,2次及以上得0分',value:6},
    {label:'0次得2分,1次及以上每次少1分',value:7},
    {label:'0次得10分,1次得8分,2次得5分,3次及以上得0分',value:9},
    {label:'達成率≥95%,得10分;95%>達成率≥90%,得8分;90%>達成率≥80%,得5分;80%>達成率≥70%,得3分;70%>達成率,得0分', value: 10},
]

export {
    sumSidebar,
    tableSeleType,
    designFormulas,
}